<template>
    <div>
        <Row :style="{display:isNextSearchDisp?'block':'none'}">
            <div style="float: left;">
                <DatePicker type="daterange" split-panels confirm format="yyyy-MM-dd" placement="bottom-end" style="padding-left: 5px;" placeholder="请选择时间范围" :editable="false" v-model="timeZone" @on-change="timeOnChange"></DatePicker>
            </div>
            <div style="float: left;padding-left: 5px;"><Input v-model="text" :maxlength="searchTextMaxlength" search enter-button="查询" @on-search="nextSearch" :placeholder="isRegulations?'当前区域适用法规查询':'请输入查询内容'" /></div>
        </Row>
        <div :style="{display:isNextSearchDisp?'block':'none',height:'5px',lineHeight:'5px'}" />
    </div>
</template>
<script>
import store from '../../../store/'
import More from "../../../api/common/more.js"
let MoreFun = new More()
export default {
    name: 'NextSearchBar',
    props: {
        isHidden: Boolean, //默认是否显示
    },
    data() {
        return {
            isNextSearchDisp: this.isHidden,
            timeZone: ["", ""],
            text: "",
            searchTextMaxlength: 100,
            isRegulations:this.$router.history.current.name==='localindex'?true:false,
        }
    },
    mounted(){
        //console.log('router333===>',this.$router.history.current.name)
    },
    created() {
        //console.log("isNextSearchDisp:"+this.isNextSearchDisp)
    },
    methods: {
        timeOnChange() {
            var time = []
            if (this.timeZone[0] !== "") {
                time[0] = MoreFun.getFormattedDate(this.timeZone[0])
                time[1] = MoreFun.getFormattedDate(this.timeZone[1])
                this.timeZone = time
                //this.$emit("on-time-change",this.timeZone)
            } else {

            }
        },
        nextSearch() {
            let searchCondition = {}
            searchCondition.time = this.timeZone
            searchCondition.text = this.text
            this.$emit('next-search', searchCondition)
        },
        display(isShow) {
            this.isNextSearchDisp = isShow
        },
        resetCondition() {
            this.timeZone = []
            this.text = ""
        },
        getNextCondition() {
            let searchCondition = {}
            searchCondition.time = this.timeZone
            searchCondition.text = this.text
            return searchCondition
        },
    }
}
</script>
<style scoped>
</style>